import { makeStyles,useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles(theme =>({
  container: {
    height: '100%',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    overflow: 'hidden',
    border: '1px solid #E2EBF6',
    borderRadius: '3px'
  },
  tableCell: {
    fontSize: '13px',
    border: 'none',
    color: '#000000',
    padding: 0
  },
  table: {
    width: '100%',
    [theme.breakpoints.down('sm')]:{
      overflowX: 'auto',
      behavior: 'smooth' ,
      display: 'block',
      width: '100%',
    }
  },
  iconButton: {
    padding: '0px 0px 0px 14px',
    '&:hover': {
      backgroundColor: 'transparent'
    }
  },
  heading: {
    color: '#071B27',
    fontWeight: 'bold',
    fontSize: '10px',
    fontFamily: 'Fira Sans',
    textTransform: 'uppercase'
  },
  nameCell: {
    width: '255px',
    fontWeight: 'bold',
    paddingLeft: '20px',
    paddingRight: '20px'
  },
  referenceCell: {
    width: '150px',
    paddingLeft: '20px'
  },
  guestsCell: {
    width: '255px',
    fontWeight: 'bold',
    paddingLeft: '20px',
    paddingRight: '20px'
  },
  addOnsCell: {
    width: '255px',
    fontWeight: 'bold',
    paddingLeft: '20px',
    paddingRight: '20px'
  },
  notesCell: {
    width: '255px',
    fontWeight: 'bold',
    paddingLeft: '20px',
    paddingRight: '20px'
  },
  unitCell: {
    alignItems: 'center',
    width: '355px',
    paddingLeft: '20px',
    wordWrap: 'break-word',
    paddingRight: '20px'
  },
  closeIcon: {
    fontSize: '21px'
  },
  checkInCheckOutCell: {
    width: '190px',
    paddingLeft: '20px',
    paddingRight: '20px'
  },
  tableRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#E2F5F8'
    }
  },
  list: {
    padding: '10px',
    margin: '0',
    fontSize: '10px',
    color: '#FFFFFF'
  },
  disabledArea: {
    position: 'relative',
    '&::after': {
      content: "''",
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      width: '100%',
      background: 'black',
      opacity: 0.2
    }
  }
}));

export default useStyles;
